import { computed, type ComputedRef } from 'vue'

import { localeRef } from '@/i18n'
import { RESUME } from '@/data/resume'
import type { ResumeContent } from '@/types/resume.types'

/**
 * Возвращает структурированный контент резюме для текущей локали.
 * Реактивно переключается вместе с локалью vue-i18n.
 */
export function useResume(): { content: ComputedRef<ResumeContent> } {
  const content = computed<ResumeContent>(() => RESUME[localeRef.value])
  return { content }
}
